var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVoidItem(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 34 23",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Actions / Icons / Void Item") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M2,0 L54,0 C55.1045695,-2.02906125e-16 56,0.8954305 56,2 L56,54 C56,55.1045695 55.1045695,56 54,56 L2,56 C0.8954305,56 1.3527075e-16,55.1045695 0,54 L0,2 C-1.3527075e-16,0.8954305 0.8954305,2.02906125e-16 2,0 Z",
    id: "void-item-path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18,0 L22.2222222,0 L22.2222222,15.0416667 L18,15.0416667 L18,0 Z M8.71111111,0 L12.9333333,0 L12.9333333,15.0416667 L8.71111111,15.0416667 L8.71111111,0 Z M14.6222222,0 L16.3111111,0 L16.3111111,15.0416667 L14.6222222,15.0416667 L14.6222222,0 Z M5.33333333,0 L7.02222222,0 L7.02222222,19 L5.33333333,19 L5.33333333,0 Z M23.9111111,0 L25.6,0 L25.6,19 L23.9111111,19 L23.9111111,0 Z",
    id: "void-item-path-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.533333333,0.5 L31.4666667,19.5",
    id: "void-item-path-5"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-4.2%",
    y: "-11.9%",
    width: "108.4%",
    height: "116.9%",
    filterUnits: "objectBoundingBox",
    id: "filter-6"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: -1,
    in: "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "erode",
    in: "SourceAlpha",
    result: "shadowInner"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: -1,
    in: "shadowInner",
    result: "shadowInner"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetOuter1",
    in2: "shadowInner",
    operator: "out",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.949019608   0 0 0 0 0.949019608   0 0 0 0 0.949019608  0 0 0 1 0",
    type: "matrix",
    in: "shadowOffsetOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons-/-Ticket-Zone-/-Actions",
    transform: "translate(-12.000000, -493.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 0.540037)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Actions-/-Icons-/-Void-Item",
    transform: "translate(0.500000, 476.214286)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#void-item-path-1"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#E5E5E5",
    d: "M2,0.5 C1.17157288,0.5 0.5,1.17157288 0.5,2 L0.5,54 C0.5,54.8284271 1.17157288,55.5 2,55.5 L54,55.5 C54.8284271,55.5 55.5,54.8284271 55.5,54 L55.5,2 C55.5,1.17157288 54.8284271,0.5 54,0.5 L2,0.5 Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-13",
    transform: "translate(12.000000, 18.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#void-item-path-3"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#757575",
    fillRule: "nonzero",
    xlinkHref: "#void-item-path-3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Line",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-6)",
    xlinkHref: "#void-item-path-5"
  }), /*#__PURE__*/React.createElement("use", {
    stroke: "#757575",
    strokeWidth: 2,
    xlinkHref: "#void-item-path-5"
  }))))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoidItem);
export default __webpack_public_path__ + "static/media/VoidItem.17770271.svg";
export { ForwardRef as ReactComponent };